<p-panel
  header="Details"
  class="existing-member-information-display-card"
  data-cy="existing-member-information-display-card"
>
  <div class="existing-member-information-card">
    <p class="consumer-tenure">
      Member since <b>{{ assignDateTime | date }}</b>
    </p>

    <div class="consumer-balance-tiles">
      <div class="consumer-balance-tile">
        <span class="consumer-balance-tile-label">Reward Balance</span>
        <span class="consumer-balance-tile-value">{{ rewardBalance | currency }}</span>
      </div>

      @if (isPointsMerchant) {
      <div class="consumer-balance-tile">
        <span class="consumer-balance-tile-label">Points Balance</span>
        <span class="consumer-balance-tile-value">{{ currentPointsBalance | number }}</span>
      </div>
      }
    </div>

    @if (lifetimeWindow) {
    <div class="consumer-spend-window-header consumer-spend-window-header-lifetime">
      <span class="consumer-spend-window-title">{{ lifetimeWindow.label }}</span>
      <span class="consumer-spend-window-rule"></span>
    </div>
    <div class="consumer-spend-window-group consumer-spend-window-group-lifetime">
      <ng-container [ngTemplateOutlet]="spendWindowMetrics" [ngTemplateOutletContext]="{ $implicit: lifetimeWindow }" />
    </div>
    } @if (rollingWindows.length) {
    <p-accordion
      class="consumer-spend-window-accordion"
      [multiple]="true"
      expandIcon="pi pi-plus"
      collapseIcon="pi pi-minus"
    >
      @for (window of rollingWindows; track window.label) {
      <p-accordionTab
        [iconPos]="'start'"
        [(selected)]="window.isOpen"
        [disabled]="!window.hasData"
        [tabStyleClass]="window.hasData ? '' : 'consumer-spend-window-tab-empty'"
      >
        <ng-template pTemplate="header">
          <span class="consumer-spend-window-title">{{ window.label }}</span>
          <span class="consumer-spend-window-rule consumer-spend-window-rule-raised"></span>
          @if (!window.isOpen) {
          <span class="consumer-spend-window-summary">
            <span class="consumer-spend-window-stat">
              <span class="consumer-spend-window-stat-label">Total Spend</span>
              <span class="consumer-spend-window-stat-value">{{ window.totalSpend | currency }}</span>
            </span>
            <span class="consumer-spend-window-stat-separator">&middot;</span>
            <span class="consumer-spend-window-stat">
              <span class="consumer-spend-window-stat-label">Visits</span>
              <span class="consumer-spend-window-stat-value">{{ window.visits | number }}</span>
            </span>
          </span>
          }
        </ng-template>

        <div class="consumer-spend-window-group">
          <ng-container [ngTemplateOutlet]="spendWindowMetrics" [ngTemplateOutletContext]="{ $implicit: window }" />
        </div>
      </p-accordionTab>
      }
    </p-accordion>
    } @if (!lifetimeWindow && !rollingWindows.length) {
    <p class="consumer-spend-window-unavailable">Spend metrics are not available for this member.</p>
    }
  </div>
</p-panel>

<ng-template #spendWindowMetrics let-window>
  <div class="consumer-loyalty-program-panel-row">
    <label>Total Spend</label>
    <span>{{ window.totalSpend | currency }}</span>
  </div>
  <div class="consumer-loyalty-program-panel-row">
    <label>Visits</label>
    <span>{{ window.visits | number }}</span>
  </div>
  <div class="consumer-loyalty-program-panel-row">
    <label>Average Spend</label>
    <span>{{ window.averageSpend | currency }}</span>
  </div>
  <div class="consumer-loyalty-program-panel-row">
    <label>Visit Frequency</label>
    <span>{{ window.visitFrequency }}</span>
  </div>
  <div class="consumer-loyalty-program-panel-row">
    <label>Rewards Earned</label>
    <span>{{ window.rewardsEarned | currency }}</span>
  </div>
  @if (isPointsMerchant) {
  <div class="consumer-loyalty-program-panel-row">
    <label>Points Earned</label>
    <span>{{ window.pointsEarned | number }}</span>
  </div>
  }
</ng-template>
